import { Component } from '@angular/core';

@Component({
  selector: 'app-personnel-reports',
  templateUrl: './personnel-reports.component.html',
  styleUrls: ['./personnel-reports.component.scss']
})
export class PersonnelReportsComponent {

}
